/**
 * Home 行動記録 popup — when to show it.
 * Spec: githubDOCS/TASKS/2026-10-26_ホームの行動記録ポップアップ_18時以降未記録の人に出す.md
 *
 * Kept as one pure function so a future condition (e.g. 「当日出勤」 once attendance data exists)
 * is one more line here.
 */

/** Fixed for everyone (owner 2026-10-26). Separate from the per-user push reminder time. */
export const CHECKIN_POPUP_FROM = '18:00';

/**
 * Everything except "is today already recorded" — that needs a fetch, so the caller only asks
 * the server when this is true.
 * @param {{ nowHHMM: string, isOwn: boolean, goals: object|null }} p
 */
export function checkinPopupEligible({ nowHHMM, isOwn, goals }) {
  if (!isOwn) return false; // someone else's home (manager view) — their record can't be saved
  if (!Array.isArray(goals?.actions) || goals.actions.length === 0) return false; // no plan
  if (goals.approvalStatus === 'pending') return false; // plan under review
  if (nowHHMM < CHECKIN_POPUP_FROM) return false; // "HH:MM" compares as text
  // × only closes it for now: the next time ホーム is opened it shows again until today is recorded
  // (owner 2026-10-26).
  return true;
}

/**
 * True when the popup should open: eligible, today's record does not exist yet, and today is a
 * working day (`todayOff` from GET /dashboard/shift — weekly / one-off days off, store 定休日).
 */
export function shouldShowCheckinPopup(p) {
  return checkinPopupEligible(p) && !p.todayRecorded && !p.todayOff;
}
